import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./client";

export async function getDepartments(): Promise<string[]> {
  const res = await apiClient.get<string[]>("/departments");
  return res.data;
}

export function useDepartments() {
  return useQuery({
    queryKey: ["departments"],
    queryFn: getDepartments,
  });
}
